import { AVAILABLE_BETWEEN, MAX_VEHICLE_AGE, MIN_INCLUDED_DISTANCE_PER_NIGHT, PRICE_RANGE } from '~/config/filterKeys';
import { getFilterValue } from '~/helpers/queryParser';

export default {
    methods: {
        dispatchNoResultsEvent(query) {
            const dates = getFilterValue(query, AVAILABLE_BETWEEN);
            const start = dates?.from && this.$options.filters.dateFormat(dates.from, 'dd.MM.');
            const end = dates?.to && this.$options.filters.dateFormat(dates.to, 'dd.MM.yyyy');
            const price = getFilterValue(query, PRICE_RANGE);
            const minIncludedDistancePerNight = getFilterValue(query, MIN_INCLUDED_DISTANCE_PER_NIGHT);
            const maxVehicleAgeFormatted = getFilterValue(query, MAX_VEHICLE_AGE)?.replace(',', '-');

            const mappedFilters = Object.keys(query).map(entry => {
                if (entry === AVAILABLE_BETWEEN) {
                    return `${entry}: ${start}-${end}`;
                }

                if (entry === PRICE_RANGE) {
                    const [from, to, currency] = price;
                    const formattedPriceRange = price && `${from}-${to} ${currency?.toUpperCase()}`;

                    return `${entry}: ${formattedPriceRange}`;
                }

                if (entry === MIN_INCLUDED_DISTANCE_PER_NIGHT) {
                    const minIncludedDistancePerNightFormatted =
                        minIncludedDistancePerNight !== -1
                            ? minIncludedDistancePerNight.replace(',', '-')
                            : minIncludedDistancePerNight;

                    return `${entry}: ${minIncludedDistancePerNightFormatted}`;
                }

                if (entry === MAX_VEHICLE_AGE) {
                    return `${entry}: ${maxVehicleAgeFormatted}`;
                }

                return `${entry}: ${query[entry]}`;
            });

            window.dataLayer?.push({
                event: 'filter_no_results',
                label: mappedFilters.join(', '),
                locale: this.$i18n.locale,
            });
        },
    },
};
